// Autofocus is intentional
/* eslint-disable jsx-a11y/no-autofocus */
import React, { forwardRef, useContext, useRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { useOverlay } from "../../__compat__/@react-aria/overlays/main.entry.mjs.mjs";
import { useDialog } from "../../__compat__/@react-aria/dialog/main.entry.mjs.mjs";
import { FocusScope } from "../../__compat__/@react-aria/focus/main.entry.mjs.mjs";
import { useMergedRef } from "../../hooks/useMergedRef.mjs.mjs";
import { pickAriaProps } from "../../interfaces/commonProps.mjs.mjs";
import { Overlay } from "../DatePicker/Overlay/index.mjs.mjs";
import { PopoverContext, containerPadding } from "./context.mjs.mjs";
import { StyledPopover, StyledPopoverBody, StyledPopoverContainer, StyledTip, StyledTriangle, StyledPopoverBodyInner, } from "./Popover.styles.mjs.mjs";
const Tip = (props) => (React.createElement(StyledTip, { ...props },
    React.createElement(StyledTriangle, { points: "10 0 20 12 0 12" })));
export const PopoverBody = ({ children, ...restProps }) => (React.createElement(StyledPopoverBody, { ...restProps, role: "none" },
    React.createElement(StyledPopoverBodyInner, { role: "none" }, children)));
const PopoverContainer = forwardRef(function PopoverContainer({ children, open = false, onClose, placement = 'bottom', autoFocus = false, tip, tipProps, triggerRef, keepContentHeight, width, ...restProps }, ref) {
    const popoverRef = useRef(null);
    const getRef = useMergedRef(ref, popoverRef);
    const { overlayProps } = useOverlay({
        onClose,
        isOpen: open,
        isDismissable: true,
        shouldCloseOnInteractOutside: (target) => { var _a; 
        // don't call `onClose` when the invoker is the trigger
        return !((_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)); },
    }, popoverRef);
    const { dialogProps } = useDialog(pickAriaProps(restProps), popoverRef);
    return (React.createElement(FocusScope, { contain: true, restoreFocus: true, autoFocus: autoFocus },
        React.createElement(StyledPopover, { open: open, ...restProps, ...overlayProps, ...dialogProps, containerPadding: containerPadding, placement: placement, tip: tip, ref: getRef, keepContentHeight: keepContentHeight, width: width },
            React.createElement(StyledPopoverContainer, null, children),
            tip && React.createElement(Tip, { ...tipProps, placement: placement }))));
});
export const Popover = ({ children, ...restProps }) => {
    const { open, ref, onExiting, onExited, ...contextProps } = useContext(PopoverContext);
    return (React.createElement(Overlay, { open: open, transitionDuration: 125, onExiting: onExiting, onExited: onExited },
        React.createElement(PopoverContainer, { ref: ref, open: open, ...restProps, ...contextProps }, children)));
};
//# sourceMappingURL=Popover.mjs.mjs.map